import { useRef } from 'react';
import { useInputHistory } from '../hooks/useInputHistory';
import { registry } from '../sceneRegistry';

export function GuessInput() {
    const inputRef = useRef<HTMLInputElement>(null);
    const history = useInputHistory();

    const submit = () => {
        const input = inputRef.current;
        if (!input) return;
        registry.game?.handleGuess(input.value);
        history.push(input.value);
        input.value = '';
        input.focus();
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const input = inputRef.current;
        if (!input) return;

        if (e.key === 'Enter') {
            submit();
        } else if (e.key === 'Escape') {
            input.value = '';
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const val = history.up(input.value);
            if (val !== null) {
                input.value = val;
                input.focus();
                input.setSelectionRange(val.length, val.length, 'none');
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const val = history.down();
            if (val !== null) {
                input.value = val;
                input.focus();
                input.setSelectionRange(val.length, val.length, 'none');
            }
        }
    };

    return (
        <section className="overlay-container-bottom">
            <div className="ui-overlay">
                <input
                    ref={inputRef}
                    type="text"
                    id="guess-input"
                    className="guess-box"
                    placeholder="Enter your guess"
                    onKeyDown={handleKeyDown}
                />
                <button id="guess-button" className="guess-button" onClick={submit}>
                    Submit Guess
                </button>
            </div>
        </section>
    );
}
